import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { IContractSeasonState } from '../../../../types/contracts/contractTypes';
import useTranslate from '../../../../customHooks/useTranslate';
import Tooltip from '../../../../muiComponents/Tooltip';
import DotIcon from '../../../components/DotIcon';

interface RatesTableHeaderProps {
    seasons: IContractSeasonState[];
}

const RatesTableHeader = (props: RatesTableHeaderProps) => {
    const { seasons } = props;
    const title = useTranslate('room');

    return (
        <TableHead>
            <TableRow>
                <TableCell className='rates-table__header-cell'>
                    {title}
                </TableCell>
                {seasons.map((season, index) => (
                    <TableCell
                        key={'season' + season.id + index}
                        className='rates-table__header-cell --text-center'
                    >
                        <Tooltip
                            titleText={season.enabled ? 'enabled' : 'disabled'}
                        >
                            <div className='flex flex-center flex-align-center gap-5'>
                                <DotIcon
                                    truthy={season.enabled}
                                    falsy={!season.enabled}
                                />
                                {season.name}
                            </div>
                        </Tooltip>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};

export default RatesTableHeader;
